import { IJsonQuery } from './types/jsonQuery';

import { NonEmptyArray, EBalconyType } from './types';
import { getTermValue, getRangeValue } from './helpers';

export function getBalconyTypes(jsonQuery: IJsonQuery): NonEmptyArray<EBalconyType> | null {
  const balconies = getRangeValue('balconies')(jsonQuery);
  const loggia = getTermValue('loggia')(jsonQuery);

  const balconyTypes: EBalconyType[] = [];

  if (balconies && balconies.gte && balconies.gte > 0) {
    balconyTypes.push(EBalconyType.Balcony);
  }

  if (loggia) {
    balconyTypes.push(EBalconyType.Loggia);
  }

  return balconyTypes.length > 0 ? (balconyTypes as NonEmptyArray<EBalconyType>) : null;
}
